import {MojitoContainerLocalStorage, MojitoLocalStorage} from './local-storage.model';
import {LocalStorageInitializeService} from './local-storage-initialize.service';

export class LocalStorageService {
  static mojitoLocalStorageKey = 'mojito-local-storage';

  constructor() {
  }

  //#region logIn && logOut
  public static logIn(userName: string): void {
    this.initializeContainerLocalStorage(userName);
    this.setIsAuthenticated(true);
  }

  public static logOut(): void {
    this.setIsAuthenticated(false);
    const containerLocalStorage = this.getCurrentContainerLocalStorage();
    containerLocalStorage.currentUserName = '';
    this.changeContainerLocalStorage(containerLocalStorage);
  }

  //#region dynamicProperty
  public static getPropertyValue(propertyName: string, propertyDefaultValue: any): any {
    const storage = this.getCurrentLocalStorage();
    return storage && storage[propertyName] ? storage[propertyName] : propertyDefaultValue;
  }

  public static setPropertyValue(propertyName: string, propertytValue: any): void {
    const storage = this.getCurrentLocalStorage();
    storage[propertyName] = propertytValue;
    this.changeLocalStorage(storage);
  }

  private static getCurrentContainerLocalStorage(): MojitoContainerLocalStorage {
    const item = localStorage.getItem(this.mojitoLocalStorageKey);
    return item ? JSON.parse(item) as MojitoContainerLocalStorage : {} as MojitoContainerLocalStorage;
  }

  private static changeLocalStorage(storageChanged: MojitoLocalStorage): void {
    const containerLocalStorage = this.getCurrentContainerLocalStorage();
    containerLocalStorage.mojitoLocalStorageList = containerLocalStorage.mojitoLocalStorageList.map(currentStorage => {
      return currentStorage.userName === storageChanged.userName ? storageChanged : currentStorage;
    });
    this.changeContainerLocalStorage(containerLocalStorage);
  }

  private static changeContainerLocalStorage(containerLocalStorage: MojitoContainerLocalStorage): void {
    localStorage.setItem(this.mojitoLocalStorageKey, JSON.stringify(containerLocalStorage));
  }

  private static getCurrentLocalStorage(): MojitoLocalStorage {
    const mojitoLocalStorageContainer = this.getCurrentContainerLocalStorage();
    return <MojitoLocalStorage>mojitoLocalStorageContainer
      ?.mojitoLocalStorageList
      ?.find(storage => storage.userName === mojitoLocalStorageContainer.currentUserName);
  }

  private static initializeContainerLocalStorage(userName: string): void {
    let containerStoreage = this.getCurrentContainerLocalStorage();
    if (!containerStoreage) {
      containerStoreage = LocalStorageInitializeService.getContainerLocalStorageInitial(userName);
    } else {
      this.initializeLocalStorage(containerStoreage, userName);
    }
    containerStoreage.currentUserName = userName;
    this.changeContainerLocalStorage(containerStoreage);
  }

  //#endregion

  private static initializeLocalStorage(containerStoreage: MojitoContainerLocalStorage, userName: string): void {
    if (!containerStoreage.mojitoLocalStorageList.some(storage => storage.userName === userName)) {
      containerStoreage.mojitoLocalStorageList.push(LocalStorageInitializeService.getLocalStorageInitial(userName));
    }
  }

  private static setIsAuthenticated(isAuthenticated: boolean): void {
    const storage = this.getCurrentLocalStorage();
    if (storage) {
      storage.isAuthenticated = isAuthenticated;
      this.changeLocalStorage(storage);
    }
  }

  //#endregion
}
